import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import {
    PaymentMethodStatus,
    SupplierPaymentMethodQueryRow
} from '@lsq-frontend/remote-services/all-java/financing-mk1-services';
import { PaymentMethodTypeDisplay } from '../../models';

@Component({
    selector: 'payment-method-status-update-modal',
    template: `
        <div class="modal-body">
            <p
                *ngIf="paymentMethod.paymentMethodStatus == paymentMethodStatus.VERIFIED"
                [style.marginBottom]="'3rem'"
            >
                This action will change the payment method to being In Review, removing the ability
                for a supplier to receive payments. Please do not proceed unless you have reviewed
                and confirmed the proper details.
            </p>
            <p
                *ngIf="!(paymentMethod.paymentMethodStatus == paymentMethodStatus.VERIFIED)"
                [style.marginBottom]="'3rem'"
            >
                This action will verify the payment method, allowing it to receive new payments from
                FastTrack. Please do not proceed unless you have reviewed and confirmed the proper
                details.
            </p>
            <data-card>
                <p class="label">Payment Method</p>
                <p class="body">{{ paymentMethodTypeDisplay[paymentMethod.paymentMethodType] }}</p>
                <p class="body">
                    {{ paymentMethod.accountName }} (...{{ paymentMethod.accountNumber }})
                </p>
            </data-card>
        </div>
    `
})
export class PaymentMethodStatusUpdateModalComponent {
    public paymentMethod: SupplierPaymentMethodQueryRow;

    public paymentMethodTypeDisplay = PaymentMethodTypeDisplay;
    public paymentMethodStatus = PaymentMethodStatus;

    constructor(private _modalService: ModalService) {
        this.paymentMethod = this._modalService.modal.data.paymentMethod;
    }
}
